<template>
    <img src="/images/promo/hero-section/puzzle-piece.png"
     alt="Puzzle Piece" />
</template>

<script>
export default {};
</script>
